import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58cdec8b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=58cdec8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cdec8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cdec8b')) {
      api.createRecord('58cdec8b', component.options)
    } else {
      api.reload('58cdec8b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58cdec8b&scoped=true", function () {
      api.rerender('58cdec8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/testAccountLogin/index.vue"
export default component.exports